(function (angular, undefined) {
    'use strict';

    angular
        .module('blocks.lodash', []);
})(angular);